import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '8px 0',
    border: `1px solid ${theme.palette.grey[500]}`,
    padding: 16,
    borderRadius: 12
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 2fr',
    gap: 24,
    alignItems: 'flex-end'
  },
  row2: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 2fr',
    gap: 8,
    margin: '32px 0'
  },
  divider: { marginTop: '24px' },
  title: { fontWeight: 500, fontSize: 18, color: theme.palette.text.primary },
  subTitle: { fontWeight: 500, fontSize: 14 },
  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
